import React from 'react';
export var CheckboxChecked = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", className: className, focusable: "false" },
        React.createElement("g", { transform: "translate(2 2)", fill: "#f5f5f5", stroke: "#585858", strokeWidth: "4" },
            React.createElement("rect", { width: "40", height: "40", stroke: "none", fill: "none" }),
            React.createElement("rect", { x: "0.1", y: "0.1", width: "36", height: "36", fill: "none" })),
        React.createElement("g", { transform: "translate(11 10)" },
            React.createElement("path", { d: "M3.648-.443l8.18,5.1L23.423-13.085", transform: "translate(-3.648 13.085)", fill: "none", stroke: "#006ebc", strokeWidth: "5" }))));
};
export var CheckboxBlank = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", className: className, focusable: "false" },
        React.createElement("g", { fill: "#f5f5f5", stroke: "#585858", strokeWidth: "1" },
            React.createElement("rect", { width: "40", height: "40", stroke: "none" }),
            React.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", fill: "none" }))));
};
//# sourceMappingURL=icons.js.map